<template>
  <div class="statis-course">
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="日期范围">
        <DatePicker
          ref="formDate"
          type="daterange"
          placeholder="选择日期范围"
          @on-change="onDateChange"
          style="width:200px;"
          :editable="false"
          clearable
        ></DatePicker>
      </FormItem>
      <FormItem :label-width="10">
        <Input
          v-model="searchCondition.keywords"
          placeholder="请输入关键字"
          style="width:250px;"
          clearable
          @keydown.native.prevent.enter="onSearch"
        >
          <Select v-model="searchCondition.keywords_type" style="width:90px;" slot="prepend">
            <Option v-for="item in keywordsType" :value="item.key" :key="item.key">{{item.value}}</Option>
          </Select>
        </Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div>
      <Button type="primary" @click="onExport" class="btn-margin-right">批量导出</Button>
    </div>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/course/statics"
        :search="searchCondition"
        :rowsFormatter="onrowsFormatter"
        selectType
        keyField="id"
        method="post"
      >
        <template slot-scope="{row}" slot="action">
          <div>
            <Button type="text" size="small" @click="onChapter(row)">课程章节</Button>
          </div>
        </template>
      </Grid>
    </div>
    <Modal class="modal" v-model="modal.show" title="课程章节" width="800">
      <Form :model="modal.searchCondition" :label-width="70" inline>
        <FormItem label="课时情况">
          <Select v-model="modal.searchCondition.chapter_status" style="width:150px;" clearable>
            <Option
              v-for="item in modal.chapterStatus"
              :value="item.key"
              :key="item.key"
            >{{item.value}}</Option>
          </Select>
        </FormItem>
        <FormItem class="search-form-btns">
          <div class="btn-wrap form-item-search">
            <Button icon="ios-search" @click="onModalSearch">搜索</Button>
            <Button icon="md-undo" @click="onModalReset">重置</Button>
          </div>
        </FormItem>
      </Form>
      <div>
        <Button type="primary" @click="onExportChapter">批量导出</Button>
      </div>
      <div class="content">
        <Grid
          ref="modalGrid"
          :columns="modal.columns"
          :data-url="modal.dataUrl"
          :search="modal.searchCondition"
          selectType
          keyField="id"
          method="post"
        >
          <template slot-scope="{row}" slot="action">
            <div>
              <Button
                v-if="row.chapter_status=='未开始'"
                style="color: #999"
                type="text"
                size="small"
              >学员详情</Button>
              <Button v-else type="text" size="small" @click="onStudentDetail(row)">学员详情</Button>
            </div>
          </template>
        </Grid>
      </div>
    </Modal>
    <Modal v-model="studentModal.show" title="学员详情" width="700">
      <Form :model="studentModal.searchCondition" :label-width="70" inline>
        <FormItem label="学习情况">
          <Select v-model="studentModal.searchCondition.is_finish" style="width:150px;" clearable>
            <Option
              v-for="item in studentModal.studyStatus"
              :value="item.key"
              :key="item.key"
            >{{item.value}}</Option>
          </Select>
        </FormItem>
        <FormItem class="search-form-btns">
          <div class="btn-wrap form-item-search">
            <Button icon="ios-search" @click="onStudentModalSearch">搜索</Button>
            <Button icon="md-undo" @click="onStudentModalReset">重置</Button>
          </div>
        </FormItem>
      </Form>
      <div>
        <Button type="primary" @click="onExportStudent">批量导出</Button>
      </div>
      <div class="content">
        <Grid
          ref="studentModalGrid"
          :columns="studentModal.columns"
          :data-url="studentModal.dataUrl"
          :search="studentModal.searchCondition"
          :rowsFormatter="onStudentrowsFormatter"
          selectType
          keyField="id"
          method="post"
        ></Grid>
      </div>
    </Modal>
  </div>
</template>

<script>
import { CouseType, StudyStatus } from "@/utils/enums";

export default {
  name: "statis-course",
  data() {
    return {
      searchCondition: {
        keywords_type: "title",
        keywords: "",
        created_at_start: "",
        created_at_end: "",
        init: function() {
          this.keywords_type = "title";
          this.keywords = "";
          this.created_at_start = "";
          this.created_at_end = "";
        }
      },
      keywordsType: [{ key: "title", value: "课程名称" }],
      tableColumns: [
        { title: "课程名称", key: "title", minWidth: 180 },
        {
          title: "课程类型",
          key: "course_type_name",
          align: "center",
          minWidth: 120
        },
        { title: "授课老师", key: "teacher", align: "center", minWidth: 180 },
        { title: "课时数量", key: "total_bte", align: "center", minWidth: 100 },
        {
          title: "已开始课时",
          key: "finish_bte",
          align: "center",
          minWidth: 100
        },
        {
          title: "剩余课时",
          key: "left_bte",
          align: "center",
          minWidth: 100
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 100,
          fixed: "right"
        }
      ],
      modal: {
        show: false,
        columns: [
          { title: "课时名称", key: "title", minWidth: 140 },
          {
            title: "学习人数",
            key: "study_all_num",
            align: "center",
            minWidth: 100
          },
          {
            title: "已完成学习人数",
            key: "study_finish_num",
            align: "center",
            minWidth: 100
          },
          {
            title: "未完成学习人数",
            key: "study_unfinish_num",
            align: "center",
            minWidth: 100
          },
          {
            title: "课时情况",
            key: "chapter_status",
            align: "center",
            minWidth: 120
          },
          {
            title: "操作",
            slot: "action",
            align: "center",
            minWidth: 120,
            fixed: "right"
          }
        ],
        dataUrl: "",
        searchCondition: {
          course_basis_id: "",
          chapter_status: "",
          init: function() {
            this.chapter_status = "";
          }
        },
        chapterStatus: [
          { key: 0, value: "未开始" },
          { key: 1, value: "已开始" }
        ]
      },
      studentModal: {
        show: false,
        columns: [
          { title: "学员名称", key: "nickname" },
          { title: "手机号码", key: "mobile", align: "center" },
          { title: "学习时长（分）", key: "study_time", align: "center" },
          { title: "学习情况", key: "is_finish", align: "center" }
        ],
        dataUrl: "",
        searchCondition: {
          chapter_id: "",
          is_finish: "",
          init: function() {
            this.is_finish = "";
          }
        },
        studyStatus: StudyStatus.getOptions()
      }
    };
  },
  methods: {
    onDateChange(range) {
      this.searchCondition.created_at_start = range[0];
      this.searchCondition.created_at_end = range[1];
    },
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.init();
      this.$refs.formDate.handleClear();
      this.$refs.grid.searchRefresh();
    },
    onExport() {
      if (!this.$refs.grid.getTotal()) {
        this.$Message.info("暂无数据可导出");
        return;
      }
      this.$http
        .post("/api/course/statics/export", this.searchCondition)
        .then(data => {
          window.open(data.url);
        });
    },
    onExportChapter() {
      if (!this.$refs.modalGrid.getTotal()) {
        this.$Message.info("暂无数据可导出");
        return;
      }
      this.$http
        .post("/api/course/chapter/statics/export", this.modal.searchCondition)
        .then(data => {
          window.open(data.url);
        });
    },
    onExportStudent() {
      if (!this.$refs.studentModalGrid.getTotal()) {
        this.$Message.info("暂无数据可导出");
        return;
      }
      this.$http
        .post(
          "/api/course/users/detail/export",
          this.studentModal.searchCondition
        )
        .then(data => {
          window.open(data.url);
        });
    },
    onChapter(row) {
      this.modal.show = true;
      this.modal.searchCondition.course_basis_id = row.id;
      this.modal.dataUrl = "/api/course/chapter/statics";
      this.$nextTick(() => {
        this.$refs.modalGrid.searchRefresh();
      });
    },
    onrowsFormatter(rows) {
      rows.forEach(i => {
        i.course_type_name = CouseType.getValue(i.course_type);
      });
    },
    onModalSearch() {
      this.$refs.modalGrid.searchRefresh();
    },
    onModalReset() {
      this.modal.searchCondition.init();
      this.$refs.modalGrid.searchRefresh();
    },
    onStudentDetail(row) {
      this.studentModal.show = true;
      this.studentModal.searchCondition.chapter_id = row.id;
      this.studentModal.dataUrl = "/api/course/users/detail";
      this.$nextTick(() => {
        this.$refs.studentModalGrid.searchRefresh();
      });
    },
    onStudentModalSearch() {
      this.$refs.studentModalGrid.searchRefresh();
    },
    onStudentModalReset() {
      this.studentModal.searchCondition.init();
      this.$refs.studentModalGrid.searchRefresh();
    },
    onStudentrowsFormatter(rows) {
      rows.forEach(i => {
        i.is_finish = StudyStatus.getValue(i.is_finish);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  .ivu-btn-text {
    color: #2d8cf0;
  }
}
</style>